"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Collection", {
  enumerable: true,
  get: function get() {
    return _Collection["default"];
  }
});
exports["default"] = void 0;
var _Collection = _interopRequireDefault(require("./Collection"));
var _default = exports["default"] = _Collection["default"];